import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../utils/api';
import { toast } from 'sonner';
import './OnetimeProductsAdmin.css';

function OnetimeProductsAdmin() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editPrice, setEditPrice] = useState('');

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const data = await apiClient.getOnetimeProducts();
      setProducts(data);
    } catch (error) {
      console.error('Error loading products:', error);
      toast.error('Fehler beim Laden der Produkte');
    } finally {
      setLoading(false);
    }
  };

  const handleEditPrice = (product) => {
    setEditingProduct(product.id);
    setEditPrice(product.price.toString());
  };

  const handleSavePrice = async (productId) => {
    try {
      await apiClient.updateOnetimeProduct(productId, {
        price: parseFloat(editPrice)
      });
      toast.success('Preis aktualisiert');
      setEditingProduct(null);
      loadProducts();
    } catch (error) {
      toast.error('Fehler beim Aktualisieren: ' + (error.response?.data?.detail || error.message));
    }
  };

  const handleViewOrders = async (productId) => {
    try {
      const orders = await apiClient.getProductOrders(productId);
      // TODO: Show orders in modal or navigate to orders page
      console.log('Product orders:', orders);
      toast.info(`${orders.length} Bestellungen gefunden`);
    } catch (error) {
      toast.error('Fehler beim Laden der Bestellungen');
    }
  };

  const handleViewProduct = (productId) => {
    window.open(`/shop/product/${productId}`, '_blank');
  };

  if (loading) {
    return (
      <div className="onetime-products-loading">
        <div className="spinner"></div>
        <p>Lade Produkte...</p>
      </div>
    );
  }

  return (
    <div className="onetime-pricing-admin" data-testid="onetime-products-admin">
      <div className="admin-header">
        <h2 className="admin-title">💰 Einmalpreise</h2>
      </div>
      
      <div className="onetime-products">
        {products.map((product) => (
          <div key={product.id} className="product-card" data-testid={`product-${product.id}`}>
            <div className="product-header">
              <h3>
                {product.icon} {product.name}
              </h3>
              <span className="product-badge">Einmalzahlung</span>
            </div>
            
            <div className="product-description">
              {product.description}
            </div>
            
            <div className="product-price">
              {editingProduct === product.id ? (
                <div className="edit-price-form">
                  <input
                    type="number"
                    value={editPrice}
                    onChange={(e) => setEditPrice(e.target.value)}
                    step="0.01"
                    min="0"
                    className="price-input"
                  />
                  <span className="price-label">€</span>
                  <button 
                    onClick={() => handleSavePrice(product.id)}
                    className="btn-save-price"
                  >
                    💾 Speichern
                  </button>
                  <button 
                    onClick={() => setEditingProduct(null)}
                    className="btn-cancel-edit"
                  >
                    ✖️
                  </button>
                </div>
              ) : (
                <>
                  <span className="price-amount">{product.price.toFixed(2)} €</span>
                  <span className="price-label">einmalig</span>
                </>
              )}
            </div>
            
            <div className="product-stats">
              <div className="stat-item">
                <span className="stat-label">Verkauft</span>
                <span className="stat-value">{product.sales_count || 0}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Umsatz</span>
                <span className="stat-value">{(product.total_revenue || 0).toFixed(2)} €</span>
              </div>
            </div>
            
            <div className="product-actions">
              <button 
                onClick={() => handleEditPrice(product)}
                className="btn-edit-product"
                disabled={editingProduct === product.id}
              >
                ✏️ Preis bearbeiten
              </button>
              <button 
                onClick={() => handleViewOrders(product.id)}
                className="btn-view-orders"
              >
                📦 Bestellungen
              </button>
              <button 
                onClick={() => handleViewProduct(product.id)}
                className="btn-view-product"
              >
                👁️ Produktseite
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OnetimeProductsAdmin;
